// 8 cardinal directions used for the 45-area block layout.
export const area45Directions = [
  { angle: -90,  label: 'N'  },
  { angle: -45,  label: 'NE' },
  { angle: 0,    label: 'E'  },
  { angle: 45,   label: 'SE' },
  { angle: 90,   label: 'S'  },
  { angle: 135,  label: 'SW' },
  { angle: 180,  label: 'W'  },
  { angle: -135, label: 'NW' },
];

// 16 main compass directions (mapped to compass-16 layer).
export const mainDirections = [
  { angle: -123.75, label: 'NNW', area: 'NNW' },
  { angle: -101.25, label: 'N',   area: 'N'   },
  { angle: -78.75,  label: 'NNE', area: 'NNE' },
  { angle: -56.25,  label: 'NE',  area: 'NE'  },
  { angle: -33.75,  label: 'ENE', area: 'ENE' },
  { angle: -11.25,  label: 'E',   area: 'E'   },
  { angle: 11.25,   label: 'ESE', area: 'ESE' },
  { angle: 33.75,   label: 'SE',  area: 'SE'  },
  { angle: 56.25,   label: 'SSE', area: 'SSE' },
  { angle: 78.75,   label: 'S',   area: 'S'   },
  { angle: 101.25,  label: 'SSW', area: 'SSW' },
  { angle: 123.75,  label: 'SW',  area: 'SW'  },
  { angle: 146.25,  label: 'WSW', area: 'WSW' },
  { angle: 168.75,  label: 'W',   area: 'W'   },
  { angle: -168.75, label: 'WNW', area: 'WNW' },
  { angle: -146.25, label: 'NW',  area: 'NW'  },
];

// 32 Mahavastu zones (compass-32 layer).
export const all32Directions = [
  // North quadrant (N5–N8)
  { angle: -90,    label: 'N5', area: 'N5' },
  { angle: -78.75, label: 'N6', area: 'N6' },
  { angle: -67.5,  label: 'N7', area: 'N7' },
  { angle: -56.25, label: 'N8', area: 'N8' },

  // East quadrant (E1–E8)
  { angle: -45,    label: 'E1', area: 'E1' },
  { angle: -33.75, label: 'E2', area: 'E2' },
  { angle: -22.5,  label: 'E3', area: 'E3' },
  { angle: -11.25, label: 'E4', area: 'E4' },
  { angle: 0,      label: 'E5', area: 'E5' },
  { angle: 11.25,  label: 'E6', area: 'E6' },
  { angle: 22.5,   label: 'E7', area: 'E7' },
  { angle: 33.75,  label: 'E8', area: 'E8' },

  // South quadrant (S1–S8)
  { angle: 45,     label: 'S1', area: 'S1' },
  { angle: 56.25,  label: 'S2', area: 'S2' },
  { angle: 67.5,   label: 'S3', area: 'S3' },
  { angle: 78.75,  label: 'S4', area: 'S4' },
  { angle: 90,     label: 'S5', area: 'S5' },
  { angle: 101.25, label: 'S6', area: 'S6' },
  { angle: 112.5,  label: 'S7', area: 'S7' },
  { angle: 123.75, label: 'S8', area: 'S8' },

  // West quadrant (W1–W8)
  { angle: 135,     label: 'W1', area: 'W1' },
  { angle: 146.25,  label: 'W2', area: 'W2' },
  { angle: 157.5,   label: 'W3', area: 'W3' },
  { angle: 168.75,  label: 'W4', area: 'W4' },
  { angle: 180,     label: 'W5', area: 'W5' },
  { angle: -168.75, label: 'W6', area: 'W6' },
  { angle: -157.5,  label: 'W7', area: 'W7' },
  { angle: -146.25, label: 'W8', area: 'W8' },

  // North quadrant tail (N1–N4)
  { angle: -135,    label: 'N1', area: 'N1' },
  { angle: -123.75, label: 'N2', area: 'N2' },
  { angle: -112.5,  label: 'N3', area: 'N3' },
  { angle: -101.25, label: 'N4', area: 'N4' },
];

// 64 zones (Vedic "64 Grid" layer) — same base line as all32Directions
// (N4|N5 boundary = due North = angle -90), just twice as fine (5.625° each),
// numbered 1-64 clockwise starting right after that boundary.
export const all64Directions = Array.from({ length: 64 }, (_, i) => {
  const angle = -90 + i * 5.625;
  const label = String(i + 1);
  return { angle, label, area: label };
});

// 8 cardinal directions with full area names.
export const directions8 = [
  { angle: -90,  label: 'N',  area: 'North'      },
  { angle: -45,  label: 'NE', area: 'North-East' },
  { angle: 0,    label: 'E',  area: 'East'       },
  { angle: 45,   label: 'SE', area: 'South-East' },
  { angle: 90,   label: 'S',  area: 'South'      },
  { angle: 135,  label: 'SW', area: 'South-West' },
  { angle: 180,  label: 'W',  area: 'West'       },
  { angle: -135, label: 'NW', area: 'North-West' },
];

// 24 sub-directions (compass-24 / Surya-Chandra-Bhag layer).
export const directions24 = [
  { angle: -90,  label: 'D1',  area: 'North'       },
  { angle: -75,  label: 'D2',  area: 'NNE'         },
  { angle: -60,  label: 'D3',  area: 'NE'          },
  { angle: -45,  label: 'D4',  area: 'ENE'         },
  { angle: -30,  label: 'D5',  area: 'East-North'  },
  { angle: -15,  label: 'D6',  area: 'East'        },

  { angle: 0,    label: 'D7',  area: 'East'        },
  { angle: 15,   label: 'D8',  area: 'ESE'         },
  { angle: 30,   label: 'D9',  area: 'SE'          },
  { angle: 45,   label: 'D10', area: 'SSE'         },
  { angle: 60,   label: 'D11', area: 'South-East'  },
  { angle: 75,   label: 'D12', area: 'South'       },

  { angle: 90,   label: 'D13', area: 'South'       },
  { angle: 105,  label: 'D14', area: 'SSW'         },
  { angle: 120,  label: 'D15', area: 'SW'          },
  { angle: 135,  label: 'D16', area: 'WSW'         },
  { angle: 150,  label: 'D17', area: 'West-South'  },
  { angle: 165,  label: 'D18', area: 'West'        },

  { angle: 180,  label: 'D19', area: 'West'        },
  { angle: -165, label: 'D20', area: 'WNW'         },
  { angle: -150, label: 'D21', area: 'NW'          },
  { angle: -135, label: 'D22', area: 'NNW'         },
  { angle: -120, label: 'D23', area: 'North-West'  },
  { angle: -105, label: 'D24', area: 'North'       },
];
